/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {LOADING_DIRECTIVES} from './index';
export class ClrLoadingModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{imports: [CommonModule], declarations: [LOADING_DIRECTIVES], exports: [LOADING_DIRECTIVES]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrLoadingModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrLoadingModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrLoadingModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
